import type { ResolvedLandingPage } from '../landingPage';

// Read-only preview pill shown beneath landing-page dropdowns. Renders the
// raw template string with placeholders (not substituted) so the author can
// see what pattern they're selecting before save. Per-location substitution
// + UTM appending happens server-side at AccountCampaign snapshot in P2b.

export function LandingPagePreview({ resolved }: { resolved: ResolvedLandingPage }) {
  if (resolved.status === 'inherit') {
    return (
      <p className="text-xs text-slate-500 mt-1">
        Inherits from Overview — see the preview above.
      </p>
    );
  }
  if (resolved.status === 'empty') {
    return (
      <p className="text-xs text-amber-700 mt-1">
        <span className="font-medium">Preview:</span> {resolved.reason}
      </p>
    );
  }
  return (
    <p className="text-xs text-slate-500 mt-1">
      <span className="font-medium">Resolves to:</span>{' '}
      <code className="font-mono text-xs break-all">{resolved.url}</code>
    </p>
  );
}
